<template>
  <div>
    <div v-if="info">
      <div class="aidio-box">
        <div class="aidio-content">
          <img
            src="../assets/pause-icon.png"
            alt=""
            v-if="isPlay"
            @click="playMusic"
          />
          <img src="../assets/play-icon.png" alt="" v-else @click="playMusic" />
          <input
            type="range"
            class="rangeMain"
            :style="{ backgroundSize: rangeBgSize }"
            :max="duration"
            :value="currentSeconds"
            @input="onRangeInput"
          />
          <div>{{ currentTime }} / {{ totalTime }}</div>
        </div>
        <audio
          ref="audioRef"
          class="audioBox"
          :src="info.cover"
          @ended="onAudioEnded"
        ></audio>
      </div>
      <div class="audio-centent">
        <img
          src="../assets/back-icon.png"
          alt=""
          class="back-icon"
          @click="goBack"
        />
        <p class="title">{{ info.name }}</p>
        <div>来源：{{ info.company }}</div>
        <div>词/曲作者：{{ info.author }}</div>
        <div class="intro-title">歌词展示：</div>
        <div v-html="info.contents"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from '../api/index';

export default {
  data() {
    return {
      isPlay: false,
      totalTime: '00:00',
      duration: 0,
      currentSeconds: 0,
      currentTime: '00:00',
      info: null,
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    // 先获取总时长再监听播放进度，避免百分比计算出现 NaN
    setTimeout(() => {
      this.getAudioTotalTime();
      this.watchMusicTime();
    }, 500);
  },
  computed: {
    progressPercent() {
      if (!this.duration) return 0;
      const percent = (this.currentSeconds / this.duration) * 100;
      return Math.max(0, Math.min(100, Math.floor(percent)));
    },
    rangeBgSize() {
      return this.progressPercent + '% 100%';
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      getDetail({
        id: this.$route.query.id,
      }).then((res) => {
        if (res.code === 200) {
          this.info = res.data;
        } else {
        }
      });
    },
    // 获取当前播放进度
    watchMusicTime() {
      const musicDom = this.$refs.audioRef;
      musicDom.addEventListener(
        'timeupdate',
        () => {
          let timeDisplay;
          //用秒数来显示当前播放进度
          timeDisplay = Math.floor(musicDom.currentTime || 0); //获取实时时间
          this.currentSeconds = timeDisplay; // 同步range的值
          this.currentTime = this.formateTime(timeDisplay);
        },
        false,
      );
    },
    getAudioTotalTime() {
      const musicDom = this.$refs.audioRef;
      if (!musicDom) return;

      musicDom.load();
      musicDom.oncanplay = () => {
        this.duration = Math.floor(musicDom.duration);
        this.totalTime = this.formateTime(musicDom.duration);
      };
    },
    playMusic() {
      this.isPlay = !this.isPlay;
      if (this.isPlay) {
        // 若上次已播放结束，currentTime已被重置为0，此处直接播放即可
        this.$refs.audioRef.play();
      } else {
        this.$refs.audioRef.pause();
      }
    },
    // 播放结束时重置状态，确保再次点击从头开始
    onAudioEnded() {
      const audio = this.$refs.audioRef;
      this.isPlay = false;
      if (audio) {
        audio.currentTime = 0;
      }
      this.currentSeconds = 0;
      this.currentTime = '00:00';
    },
    // 拖动进度条时调整音频播放进度
    onRangeInput(e) {
      const val = Number(e.target.value || 0);
      const audio = this.$refs.audioRef;
      if (!audio || !this.duration) return;
      audio.currentTime = val;
      this.currentSeconds = val; // 立即更新UI显示
      this.currentTime = this.formateTime(val);
    },
    formateTime(time) {
      //分钟
      var minute = time / 60;
      var minutes = Math.floor(minute);
      var minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
      //秒
      var second = time % 60;
      var seconds = Math.floor(second);
      var secondsStr = seconds < 10 ? '0' + seconds : seconds.toString();
      return minutesStr + ':' + secondsStr;
    },
  },
};
</script>

<style lang="less" scoped>
.aidio-box {
  width: 375px;
  height: 170px;
  background: url('../assets/audio-bg.png');
  background-size: 100% 100%;
  padding-top: 50px;
  box-sizing: border-box;

  .aidio-content {
    width: 332px;
    height: 70px;
    background: url('../assets/audio-bg-1.png');
    background-size: 100% 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    > img {
      width: 37px;
      height: 37px;
      margin-right: 11px;
    }
    > div {
      font-size: 13px;
      color: #000000;
    }

    .rangeMain {
      width: 159px;
      margin-right: 10px;
      -webkit-appearance: none; /*清除系统默认样式*/
      background: linear-gradient(#a3cfff, #a3cfff) no-repeat, #eef0f3; /* 前景填充色 + 背景轨道色 */
      background-size: 0% 100%;
      transition: background-size 0.1s linear; /* 让填充更顺滑 */
      outline: none;
      -webkit-appearance: none; /*清除系统默认样式*/
      height: 5px; /*横条的高度*/
      border-radius: 3px;
    }
    .rangeMain::-webkit-slider-thumb {
      -webkit-appearance: none; /*清除系统默认样式*/
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background-color: #fff;
      -webkit-appearance: none;
      border: 0;
      margin-top: -3px;
    }
    .rangeMain::-webkit-slider-runnable-track {
      height: 5px;
      border-radius: 3px;
      background-color: transparent; /* 让背景由上面的background控制 */
    }
  }
}
.audio-centent {
  padding: 15px 20px;
  border-radius: 15px 15px 0px 0px;
  width: 375px;
  box-sizing: border-box;
  position: relative;
  top: -15px;
  z-index: 10;
  background: #fff;
  .title {
    font-size: 16px;
    color: #000000;
    margin-bottom: 13px;
  }
  > div {
    font-size: 16px;
    color: #666666;
    margin-bottom: 10px;
  }
  .intro-title {
    margin-bottom: 6px;
  }
}
.back-icon {
  width: 91px;
  height: 20px;
  margin-bottom: 13px;
}
</style>